
import React, { createContext, useState, useContext, useEffect } from 'react';


const StateContext = createContext();


export const ProjectIdContext = () => useContext(StateContext);


export const ProjectProvider = ({ children }) => {


    const [ProjectID, setProjectID] = useState(localStorage.getItem('projectID'));
    const [ProjectName, setProjectName] = useState(localStorage.getItem('projectName'));



    useEffect(() => {
        setProjectID(ProjectID)
        localStorage.setItem('projectID',ProjectID)
    }, [ProjectID]);

    useEffect(() => {
        setProjectName(ProjectName)
        localStorage.setItem('projectName',ProjectName)
    }, [ProjectName]);



    return (
        <StateContext.Provider value={{ ProjectID, setProjectID, ProjectName, setProjectName }}>
            {children}
        </StateContext.Provider>
    );
};
